import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';

import type { CountryCodeFieldData } from '@xing-com/crate-jobs-domain-apply-helpers';
import {
  defaultCountryCodeValues,
  getDialCodeFromCountryCode,
} from '@xing-com/crate-jobs-domain-apply-helpers';
import { GetApplyCountryCodesDocument } from '@xing-com/crate-jobs-graphql';

type UseCountryCodesResult = CountryCodeFieldData[];

export const useCountryCodes = (): UseCountryCodesResult => {
  const [countries, setCountries] = useState<CountryCodeFieldData[]>(
    defaultCountryCodeValues
  );
  const { data } = useQuery(GetApplyCountryCodesDocument);

  useEffect(() => {
    const countries = data?.countries
      ?.map(({ countryCode, name }): CountryCodeFieldData | undefined =>
        getDialCodeFromCountryCode(countryCode) !== undefined
          ? {
              name: name,
              dialCode: getDialCodeFromCountryCode(countryCode),
              countryCode: countryCode,
            }
          : undefined
      )
      .filter(Boolean);

    if (countries) {
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      setCountries(countries as CountryCodeFieldData[]);
    }
  }, [data]);

  return countries;
};
